// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-desk-container .help-desk-messenger {
  z-index: 10000;
  position: fixed;
  bottom: 20px;
  /* right: 20px; */
  width: 376px;
  min-height: 250px;
  max-height: 704px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
  opacity: 1;
  border-radius: 8px;
  overflow: hidden;
}

.help-desk-container .help-desk-messenger > iframe {
  width: 100%;
  height: 100%;
  position: absolute;
}

`, "",{"version":3,"sources":["webpack://./dist/src/components/layout/chat-container/chat-container.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".help-desk-container .help-desk-messenger {\r\n  z-index: 10000;\r\n  position: fixed;\r\n  bottom: 20px;\r\n  /* right: 20px; */\r\n  width: 376px;\r\n  min-height: 250px;\r\n  max-height: 704px;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;\r\n  opacity: 1;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.help-desk-container .help-desk-messenger > iframe {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
